const guiColors = {
    'motion-primary': '#ff8e4c',
    'motion-primary-transparent': 'rgba(255, 139, 76, 0.9)',
    'motion-tertiary': 'rgb(204, 156, 51)',

    'looks-secondary': '#ff884c',
    'looks-transparent': 'rgba(255, 190, 77, 0.35)',
    'looks-light-transparent': '#ff4d4d26',
    'looks-secondary-dark': 'hsla(0, 42%, 51%, 1)',

    'data-primary': '#6992ff',

    'extensions-primary': 'hsla(10, 85%, 65%, 1)',
    'extensions-tertiary': 'rgb(189, 99, 15)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#ff8c8c'
};

const blockColors = {
    checkboxActiveBackground: 'rgb(255, 183, 76)',
    checkboxActiveBorder: 'rgb(204, 130, 51)'
};

export {
    guiColors,
    blockColors
};
